export const CART_SHARE_UUID = "cart-share-uuid";
